// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { wrapperDefault } from '../styles';
export var widerLayoutClassName = 'wider-layout';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var wrapperStyleWithoutCursor = css(wrapperDefault, {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.without-frame': {
    background: 'transparent'
  },
  width: '100%',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '.extension-overflow-wrapper:not(.with-body)': {
    overflowX: 'auto'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.with-bodied-border': {
    boxShadow: "0 0 0 1px ".concat("var(--ds-border, #091E4224)")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.with-hover-border': {
    boxShadow: "0 0 0 1px ".concat("var(--ds-border-input, #8590A2)")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.with-margin-styles': {
    margin: "0 ".concat("var(--ds-space-negative-250, -20px)"),
    padding: "0 ".concat("var(--ds-space-250, 20px)")
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var wrapperStyleInheritedCursor = css(wrapperStyleWithoutCursor, {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '.extension-overflow-wrapper:has(.extension-editable-area)': {
    cursor: 'inherit'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '.extension-overflow-wrapper:not(:has(.extension-editable-area))': {
    cursor: 'pointer'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var wrapperStyle = css(wrapperStyleWithoutCursor, {
  cursor: 'pointer'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var header = css({
  padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-050, 4px)", " 0px"),
  verticalAlign: 'middle',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&.with-children:not(.without-frame)': {
    padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-100, 8px)", " ", "var(--ds-space-100, 8px)")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.without-frame': {
    padding: 0
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var content = css({
  padding: "var(--ds-space-100, 8px)",
  background: "var(--ds-surface, white)",
  border: "1px solid ".concat("var(--ds-border, #091E4224)"),
  borderRadius: "var(--ds-border-radius, 3px)",
  cursor: 'initial',
  width: '100%',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.remove-border': {
    border: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.hide-content': {
    display: 'none'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var contentWrapper = css({
  padding: "0 ".concat("var(--ds-space-100, 8px)", " ", "var(--ds-space-100, 8px)"),
  display: 'flex',
  justifyContent: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.with-padding-styles': {
    padding: "var(--ds-space-100, 8px)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.with-bodied-padding-styles': {
    padding: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-250, 20px)") // account for upcoming editor elements drag & drop feature
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var overflowWrapperStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.with-margin-styles': {
    margin: "0 ".concat("var(--ds-space-negative-250, -20px)")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.with-padding-styles': {
    padding: "var(--ds-space-100, 8px)"
  }
});